// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"ToolbarStyles_toolbar__7LWjK","buttonsWrapper":"ToolbarStyles_buttonsWrapper__1E70o"};